import styled from "styled-components";

const ListOfAgentContainer = styled.div`
    display: flex;
    justify-content: space-around;
    width: 100%;
    flex-grow: 1;
    max-height: calc(100svh - 181px);
    @media (max-width: 768px) {
        max-height: calc(100svh - 150px);
    }
`;

const AgentListContainer = styled.div`
    padding: 15px;
    height: ${props => props.isExpanded ? `calc(100svh - 188px)` : `calc(100svh - 112px)`};
    overflow-y: auto;
    scrollbar-width: thin;
    scroll-margin-left: 8px;
    scrollbar-color: ${props => props.theme.colors.thumbGray} ${props => props.theme.colors.highClearGray};

    @media (max-width: 768px) {
        height: ${props => props.isExpanded ? `calc(100svh - 160px)` : `calc(100svh - 100px)`};
    }
`;

const AgentListCard = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: stretch;
    align-items: center;
    width: 100%;
    height: 48px;
    margin-bottom: 15px;
    gap: 8px;
    cursor: pointer;
    
    & div:nth-child(2){
        gap: 0;
    }
`;

const AgentAvatar = styled.div`
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
    display: flex;
    max-width: 32px;
    max-height: 32px;
`;

const AgentData = styled.div`
    order: 0;
    flex: 1 1 auto;
    align-self: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const AgentFavorites = styled.div`
    order: 0;
    flex: 1 1 auto;
    align-self: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 14px;
`;

const AgentName = styled.p`
    margin: 0;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap; 
    text-overflow: ellipsis;
    width: 170px;
    font-size: 0.875rem;

    @media (max-width: 768px) {
        width: 140px;
        font-size: 0.8125rem;
    }
`;

const AgentWelcome = styled.p`
    margin: 0;
    font-weight: normal;
    font-size: 14px;
    color: ${props => props.theme.colors.grayX11};
`;

const AgentDateTime = styled.p`
    margin: 0;
    font-weight: normal;
    font-size: 10px;
    color: ${props => props.theme.colors.grayX11};
`;

export {
    ListOfAgentContainer,
    AgentListContainer,
    AgentListCard,
    AgentAvatar,
    AgentData,
    AgentFavorites,
    AgentName,
    AgentWelcome,
    AgentDateTime
};
